export enum ChatSource {
  CLIENT = 'CLIENT',
  PRODUCT = 'PRODUCT'
}
